import axios from 'axios'
import $http from '@/plugins/axios'

const UserService = {
    getJwtUser (code, social_type) {
        // let url = process.env.VUE_APP_BASE_API_URL + '/social/jwt_user/fptid/'
        // let instance = axios.create({
        //     headers: {
        //         common: {
        //             'Content-Type': 'application/json'
        //         }
        //     }
        // })
        // return instance.post(url, { code, redirect_uri: `${window.location.origin}/home` })
        let url = `${process.env.VUE_APP_BASE_API_URL}/social/jwt_user/${social_type}/`
        let bodyFormData = new FormData()
        bodyFormData.append('code', code)
        bodyFormData.append('redirect_uri', `${window.location.origin}/home`)
        let instance = axios.create({
            headers: {
                common: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        })
        return instance.post(url, bodyFormData)
    },
    getProfile () {
        return window.$http.get('/user/')
    },
    getBillingInformation () {
        return $http.get(`/billing/`)
    },
    saveBillingInformation (data) {
        return $http.post(`/billing/`, data)
    },
}

export default UserService
